import { useState, useEffect } from 'react';

export default function useAuthListener() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('authUser')));

  useEffect(() => {
    // Check localStorage for user on mount
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    if (authUser) {
      setUser(authUser);
    }
  }, []);

  return { user };
}
